import { render, staticRenderFns } from "./intRank.vue?vue&type=template&id=891f30ea&"
import script from "./intRank.vue?vue&type=script&lang=js&"
export * from "./intRank.vue?vue&type=script&lang=js&"
import style0 from "./intRank.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports